import React from 'react';
import PropTypes from 'prop-types';

const LoadingBar = props => (
  <div className={`progress ${props.loadingClasses}`}>
    <div
      className="bar"
      style={{ width: `${props.percentComplete}%` }}
    />
  </div>
);

LoadingBar.propTypes = {
  percentComplete: PropTypes.number.isRequired,
  loadingClasses: PropTypes.string,
};

LoadingBar.defaultProps = {
  loadingClasses: 'progress-striped active',
};

export default LoadingBar;



// WEBPACK FOOTER //
// ./src-react/Modals/components/LoadingBarModalBody/components/LoadingBar.jsx